export type MenuItems = {
  name: string;
  url: string;
};

export const footerMenuItems: MenuItems[] = [
  /* {
    name: 'Contact Us',
    url: '#',
  },
  {
    name: 'Case Studies',
    url: '#',
  },
  {
    name: 'FAQ',
    url: '#',
  }, */
];
